import { useEffect, useState } from 'react'
import { client } from '../client'
import { detectLang } from '../types'
import type { Lang } from '../types'

export type TranslationKey =
  | 'button.seeMore'
  | 'button.next'
  | 'button.previous'
  | 'button.save'
  | 'button.close'
  | 'button.exit'

type TranslationMap = Record<string, { nb?: string; en?: string }>

export function useTranslations() {
  const [map, setMap] = useState<TranslationMap>({})
  const lang: Lang = detectLang()

  useEffect(() => {
    client
      .fetch<Array<{ key: string; nb?: string; en?: string }>>('*[_type == "translation"]{ key, nb, en }')
      .then((data) => {
        setMap(Object.fromEntries(data.map((item) => [item.key, { nb: item.nb, en: item.en }])))
      })
  }, [])

  return (key: string): string => {
    const entry = map[key]
    if (!entry) return key
    return entry[lang] ?? entry.nb ?? entry.en ?? key
  }
}
